import { useCallback } from "react";
import styles from "./nodeTypeComponents.module.css";
import { useSelector } from "react-redux";
import { useHomeReactFlow } from "@custom-hooks/HomeUsePluginRoot/useHomeReactFlow";
import classNames from "classnames";
import { uploadTypes } from "../constants";
import { Spin } from "antd";
import { NodeTitle } from "./NodeTitle";
import { Button, Input, InputRef, Popover } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import func from "@uikit/func";

const [, , ...restUploadTypes] = uploadTypes;

const NodeWrapper = ({
  id,
  isInCanvas,
  style,
  children,
  isOpenDeleteBox,
  isInBlueprint = false,
  inputTitle,
  loading,
  displayType,
  enableFeedback,
  reason = "",
  mouseEnterLeave = () => {},
  typeInputRef,
}) => {
  const cotStore = useSelector(state => state.editor.cot);
  const applicationTheme = useSelector(state => state.editor.applicationTheme);
  const isShare = useSelector(state => state.fot.isShare);

  const { deleteNodeById } = useHomeReactFlow();
  const isBluePrintNode = displayType === "blueprint";
  const deleteContent = useCallback(() => {
    id && deleteNodeById(id);
  }, [id]);
  const nodeWrapperClassName = classNames(
    styles.nodeWrapper,
    restUploadTypes.includes(displayType) && styles.bordered,
    {
      [styles["fitNodeContent"]]: displayType === "chatInterface" || (displayType === "askBrain" && !isInCanvas),
    }
  );
  return (
    <div
      data-theme={isInCanvas ? "light" : applicationTheme}
      className={nodeWrapperClassName}
      onMouseEnter={() => mouseEnterLeave(true)}
      onMouseLeave={() => mouseEnterLeave(false)}
      style={
        isShare && displayType === "video"
          ? {
              ...style,
              width: "auto",
            }
          : style
      }
    >
      {isInCanvas && (
        <NodeTitle
          id={id}
          inputTitle={inputTitle}
          displayType={displayType}
          isInBlueprint={isInBlueprint}
          typeInputRef={typeInputRef}
        />
      )}
      {isBluePrintNode && !func.isEmpty(reason) && (
        <Popover
          content={reason}
          placement="topLeft"
          trigger="click"
          overlayClassName={styles.reasonPopover}
          overlayInnerStyle={{ width: "300px" }}
        >
          <Button className={styles.reasonIcon} type="text" icon={<InfoCircleOutlined />} />
        </Popover>
      )}
      <div className={styles.nodeContent}>
        {loading === true ? <Spin spinning={loading}>{children}</Spin> : children}
      </div>
    </div>
  );
};

export default NodeWrapper;
